import { render, staticRenderFns } from "./MemberActHistory.vue?vue&type=template&id=6165ddfc&"
import script from "./MemberActHistory.vue?vue&type=script&lang=js&"
export * from "./MemberActHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6165ddfc')) {
      api.createRecord('6165ddfc', component.options)
    } else {
      api.reload('6165ddfc', component.options)
    }
    module.hot.accept("./MemberActHistory.vue?vue&type=template&id=6165ddfc&", function () {
      api.rerender('6165ddfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/members/member-manage/MemberActHistory.vue"
export default component.exports